export default __webpack_public_path__ + "static/media/TheCocktailList.9a0bbf90.jpg";